/**
 * TagEditor - toggle chips for selecting asset tags.
 *
 * Renders each tag from AVAILABLE_TAGS as a clickable chip.
 * Selected tags get a blue highlight; unselected ones are gray.
 */

import React from "react";
import { AVAILABLE_TAGS } from "../types";

interface TagEditorProps {
  selectedTags: string[];
  onChange: (tags: string[]) => void;
  disabled?: boolean;
}

export const TagEditor: React.FC<TagEditorProps> = ({
  selectedTags,
  onChange,
  disabled = false,
}) => {
  const toggleTag = (tag: string) => {
    if (disabled) return;

    const isSelected = selectedTags.includes(tag);
    if (isSelected) {
      onChange(selectedTags.filter((t) => t !== tag));
    } else {
      onChange([...selectedTags, tag]);
    }
  };

  return (
    <div className="flex flex-wrap gap-1.5">
      {AVAILABLE_TAGS.map((tag) => {
        const isSelected = selectedTags.includes(tag);
        return (
          <button
            key={tag}
            type="button"
            onClick={() => toggleTag(tag)}
            disabled={disabled}
            className={`
              px-2.5 py-1 rounded-full text-xs font-medium transition-colors
              ${
                isSelected
                  ? "bg-blue-100 text-blue-700 ring-1 ring-blue-300"
                  : "bg-gray-100 text-gray-600 hover:bg-gray-200"
              }
              ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
            `}
          >
            {tag}
          </button>
        );
      })}
    </div>
  );
};
